import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.brand("@open-revenue/schema/StoreProductId"), S.annotations({
    description: "A unique identifier for a product in the store, this could be a paddle price id, a stripe price id, or a google play product id"
}));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
